var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReadMoreArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.693 10h-2.08l4.3-4.2H.193V4.36h11.72l-4.3-4.2h2.08l5.12 4.92L9.693 10z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml,%3csvg width='15' height='10' viewBox='0 0 15 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M9.69336 10H7.61336L11.9134 5.8H0.193359V4.36H11.9134L7.61336 0.16H9.69336L14.8134 5.08L9.69336 10Z' fill='white'/%3e %3c/svg%3e";
export { SvgReadMoreArrowRight as ReactComponent };